module.exports = __webpack_public_path__ + "img/logo_esr.522e0b0b.png";